
const fields = {

    redni_broj: {
        key: 'redni_broj',
        type: 'hInput',
        templateOptions: {
            label: 'Redni broj'
        }
    },
    djelatnost: {
        key: 'djelatnost',
        type: 'huiSelect',
        templateOptions: {
            label: 'Djelatnost',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite djelatnost',
            options: [],
            allowClear: false,
            required: true
        },
        controller: ['$scope', 'DjelatnostPoliklinike', function ($scope, Model) {
            Model.findAll().then(function (response) {
                $scope.to.options = response;
            });
        }],
    },
    operacija: {
        key: 'operacija',
        type: 'hTextarea',
        templateOptions: {
            label: 'Operacija',
            rows: 3,
            cols: 50,
            required: true
        }
    },
    dijagnoza: {
        key: 'dijagnoza',
        type: 'dijagnoza',
        templateOptions: {
            label: 'Šifra dijagnoze',
            limitTo: 25
        },
    },

    dijagnoza_text: {
        key: 'dijagnoza_text',
        type: 'hTextarea',
        templateOptions : {
            label: 'Dijagnoza',
            rows: 3,
            required: true
        }
    },

    pacijent: {
        key: 'pacijent',
        type: 'huiSelect',
        templateOptions: {
            label: 'Pacijent',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite pacijenta',
            options: [],
            disabled: true
        },
        controller: ['$scope', 'Pacijent', function ($scope, Model) {
            Model.findAll().then(function (response) {
                $scope.to.options = response;
            });
        }],
    },
    napomena: {
        key: 'napomena',
        type: 'textarea',
        templateOptions: {
            // label: 'Napomena'
            rows: 10,
            cols: 50
        }
    },
    operater: {
        key: 'operater',
        type: 'hInput',
        templateOptions: {
            label: 'Operater'
        }
    },
    anesteziolog: {
        key: 'anesteziolog',
        type: 'hInput',
        templateOptions: {
            label: 'Anesteziolog'
        }
    },
    anestezioloski_tehnicar: {
        key: 'anestezioloski_tehnicar',
        type: 'hInput',
        templateOptions: {
            label: 'Anesteziološki tehničar'
        }
    },
    asistent_1: {
        key: 'asistent_1',
        type: 'hInput',
        templateOptions: {
            label: 'Asistent I'
        }
    },
    asistent_2: {
        key: 'asistent_2',
        type: 'hInput',
        templateOptions: {
            label: 'Asistent II'
        }
    },
    instrumentarka: {
        key: 'instrumentarka',
        type: 'hInput',
        templateOptions: {
            label: 'Instrumentarka'
        }
    },

    datum: {
        key: 'datum',
        type: 'hDatepicker',
        templateOptions: {
            label: 'Datum operacije',
            required: true
        }
    },

    anestezija: {
        key: 'anestezija',
        type: 'hTextarea',
        templateOptions : {
            label: 'Anestezija',
            rows: 3,
        }
    }
};

export {fields};



// WEBPACK FOOTER //
// ./app/components/nalaz/form/fields.js